import React from 'react';
import classNames from 'classnames';

const RequestDetailsStatusContent = ({ label, className }: { label: string, className: string }) => (
  <p className="drawer-title__status">
    Status:
    <span className={classNames('drawer-title__status-value', className)}>{label}</span>
  </p>
);

export default RequestDetailsStatusContent;
